<div class="flex">
  <div class="detail-row-label flex">
    <div class="flex-1">
      {{ label() }}
    </div>
    @if (help()) {
      <div (click)="op.toggle($event)">
        <i
          class="pi pi-question-circle text-info relative top-[1px] cursor-pointer"></i>
      </div>
      <p-popover #op>
        <div style="max-width: 300px; max-height: 400px; overflow: auto">
          <ng-container [ngTemplateOutlet]="help()"></ng-container>
        </div>
      </p-popover>
    }
  </div>
  <div class="detail-row-value" [class]="space()">
    @if (editMode() && editor()) {
      <ng-container [ngTemplateOutlet]="editor()"></ng-container>
    } @else {
      <ng-content></ng-content>
    }
  </div>
</div>
